export default "__VITE_ASSET__c52b4440__"